import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Row, Col, Button, Tooltip } from "antd";

import { SVGView } from "../assets-view/SVGView";
import DocumentView from "../document-view/DocumentView";
import fileextension from "file-extension";
import Magnifier from "react-magnifier";
import VideoView from "../assets-view/VideoView";
import AudioView from "../assets-view/AudioView";
import { AUDIO_EXT } from "../../utils/index";
import { getImageAssettByExtension, sendNotification } from "../../utils";

import "./bunkeyHost.css";

export class BunkeyHost extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const bunkeyHost = { nextProps };
    if (!bunkeyHost.asset) return false;

    return true;
  }

  handleSetSrc = (r) => {
    const { originalURL, mediaQualityURL } = r;
    const itemUrl =
      originalURL !== mediaQualityURL
        ? mediaQualityURL
        : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  };

  copyLinkToClipBoard = (id, name, quality) => {
    const { intl } = this.props;

    const site =
      process.env.REACT_APP_BUNKEY_ENV === "production"
        ? "https://dam.bunkey.tv"
        : process.env.REACT_APP_BUNKEY_ENV === "qa"
        ? "http://dam-qa.bunkey.tv"
        : "http://dam-dev.bunkey.tv";

    let params = `${id}/${quality}`;

    const template = `<iframe
      width="100%"
      height="100%"
      src="${site}/embed/${params}"
      title="${name}"
      frameborder="0"
      scrolling="no"
      allowfullscreen
    ></iframe>`;
    // const template = `${site}/embed/${params}`;

    navigator.clipboard.writeText(template);
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: "link_copied" })
    );
  };

  render() {
    const { intl, bunkeyHost } = this.props;
    const { asset } = bunkeyHost;
    const dotsStr = "...";
    const maxLength = 25;

    const isSliced = asset.name && asset.name.length > maxLength;
    const assetName = isSliced
      ? asset.name.slice(0, maxLength - dotsStr.length).concat(dotsStr)
      : asset.name;
    return (
      <React.Fragment>
        <Row>
          <Col span={24}>
            <div className="header-title">
              <div>
                <p> {intl.formatMessage({ id: "asset_to_insert_tittle" })}: </p>
              </div>
              <div className="asset-tittle">
                {isSliced && (
                  <Tooltip title={asset.name}>
                    <p>{assetName}</p>
                  </Tooltip>
                )}
                {!isSliced && <p>{assetName}</p>}
              </div>
            </div>
          </Col>
          <Col span={24}>
            {asset.type === "image" &&
            fileextension(asset.originalURL) === "svg" ? (
              <SVGView
                assetId={asset._id}
                comFromMiddleView={true}
                src={asset.originalURL}
              />
            ) : asset.type === "image" &&
              fileextension(asset.originalURL) !== "png" ? (
              <Magnifier
                alt={asset.name}
                src={this.handleSetSrc(asset)}
                className="responsive-img loading-middle-view"
                mgShowOverflow={false}
              />
            ) : (
              asset.type === "image" && (
                <Magnifier
                  alt={asset.name}
                  src={this.handleSetSrc(asset)}
                  className="responsive-img "
                  mgShowOverflow={false}
                />
              )
            )}
            {asset.type === "document" &&
              AUDIO_EXT.includes(fileextension(asset.originalURL)) && (
                <AudioView
                  item={asset}
                  from={`middleView`}
                  canCommentsAndVersions={false}
                />
              )}
            {asset.type === "document" &&
              !AUDIO_EXT.includes(fileextension(asset.originalURL)) && (
                <DocumentView item={asset} from={`middleView`} />
              )}
            {asset.type === "video" && (
              <VideoView
                url={asset.mediaQualityURL}
                disableDefaultControls={false}
                autoPlay={true}
                muted={false}
                canCommentsAndVersions={false}
                texto=""
                key="vista media"
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className="info-box margin-top-info">
              {/* <p className="url-style">{asset.originalURL}</p>
              <div className="divider-wrapper">
                <hr className="solid-divider" />
              </div> */}
              <div className="message-box">
                <p className="important-title-style">
                  {intl.formatMessage({ id: "important_title" })}
                </p>
                <p className="important-message-style">
                  {intl.formatMessage({
                    id: "important_original_quality_insert_message",
                  })}
                </p>
                <p className="important-message-style">
                  {intl.formatMessage({
                    id: "important_original_quality_insert_message_2",
                  })}
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="grapper-button">
            <Button
              type="primary"
              className="copy-button"
              onClick={() =>
                this.copyLinkToClipBoard(asset._id, asset.name, "original")
              }
            >
              {intl.formatMessage({ id: "copy_original_url" })}
            </Button>
          </div>
        </Row>
        <Row>
          <Col span={24}>
            <div className="info-box margin-top-info">
              {/* <p className="url-style">{asset.mediaQualityURL}</p>
              <div className="divider-wrapper">
                <hr className="solid-divider" />
              </div> */}
              <div className="message-box">
                <p className="important-title-style">
                  {intl.formatMessage({ id: "important_title" })}
                </p>
                <p className="important-message-style">
                  {intl.formatMessage({
                    id: "important_optimized_qualiy_insert_message",
                  })}
                </p>
                <p className="important-message-style">
                  {intl.formatMessage({
                    id: "important_original_quality_insert_message_2",
                  })}
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="grapper-button">
            <Button
              type="primary"
              className="copy-button"
              onClick={() =>
                this.copyLinkToClipBoard(asset._id, asset.name, "media")
              }
            >
              {intl.formatMessage({ id: "copy_optimized_url" })}
            </Button>
          </div>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bunkeyHost: state.bunkeyHost,
  };
};

export default injectIntl(withRouter(connect(mapStateToProps)(BunkeyHost)));
